import React, { useEffect, useState, useContext } from 'react';
import CheckField from '../../../../components/CheckField2/CheckField';
import './styles.scss';
import { SectionHeader } from '../../../../components/sectionHeader/sectionHeader';
import ErrorBar from '../../../../components/ErrorBar';
import { ConfigContext } from '../../DynamicForm/DynamicForm';

const FacilitiesSelectionList = ({ formik, languageText }) => {

    // state values
    const [facilities, setFacilities] = useState([]);
    const [validation, setValidation] = useState({ state: false, message: '' });
    const [facilitiesError, setFacilitiesError] = useState({ state: false, message: '' });
    const [selectedItems, setSelectedItems] = useState([]);

    // sets up context
    let appContext = useContext(ConfigContext);
    const { dbFormSpec, validationValues } = useContext(ConfigContext);
    appContext.localValues = {};
    appContext.localValues.facilityList = facilities;


    const facilityName = dbFormSpec.facility.name;
    useEffect(() => {
        formik.setFieldValue('facilityList', [facilityName])
    }, []);

    useEffect(() => {
        let facilitiesArray = []
        Object.values(formik.values.facilityList).forEach((facility, index) => {
            if (facility !== '') {
                let facilityArray = []
                Object.values(facility).forEach((property, index) => {
                    property && facilityArray.push(property)
                })
                facilitiesArray.push(`${facilityArray.join(', ')}`)
            }
        })
        setFacilities(facilitiesArray);
    }, [formik.values.facilityList]);

    // when there is an error on a single facility, set an overall error on facilities component
    useEffect(() => {
        appContext.localError = facilitiesError.state
        console.log(appContext.localError)
        console.log("facilitiesError.state", facilitiesError.state)
        console.log("appContext.localError", appContext)
    }, [facilitiesError]);

    // when formik facility list is changed, update facilityOrPhysician accordingly
    useEffect(() => {
        if (Object.values(formik.values.facilityList).every((value) => { return value.length == 0 })) {
            formik.setFieldValue('facilityOrPhysician', "")
        }
        else {
            formik.setFieldValue('facilityOrPhysician', "on")
        }
    }, [formik.values.facilityList]);



    useEffect(() => {
        formik.values.facilityList.length > 1 ? setSelectedItems(formik.values.facilityList.join(', ')) : setSelectedItems(`${languageText.FacilitySelector.SelectorInstructions}`)
    }, [formik.values.facilityList]);

    const SectionTitles = dbFormSpec.release.FacilitiesLocationsList ? dbFormSpec.release.FacilitiesLocationsList : [facilityName, languageText.FacilitySelector.LocationOne, languageText.FacilitySelector.LocationTwo, languageText.FacilitySelector.LocationThree];



    return (
        <div id='medicalFacilitiesRequested' className='form-section'>
            <SectionHeader sectionTitle={languageText.FacilitySelector.SectionTitle} styles={{ color: dbFormSpec.color }} />
            <div id='facility-disclosure-container'>
                <div className='facility-selection' id='facilityOrPhysician'>
                    {formik.errors.facilityOrPhysician && formik.touched.facilityOrPhysician && <ErrorBar message={formik.errors.facilityOrPhysician} />}
                    {(!formik.errors.facilityOrPhysician && formik.values.inputDisclosePhysicians && formik.errors.inputPhysicianNames && formik.touched.inputPhysicianNames) && <ErrorBar message={formik.errors.inputPhysicianNames} />}
                    <label className='section-instruction subtitle1'> {`${languageText.FacilitySelector.PartiesInstruction}`}</label>
                    <div style={{ marginBottom: 20 }}>{languageText.FacilitySelector.AuthCaption}</div>
                    <CheckField checkboxType={'facility'} formik={formik} formValue={'key'} checkItemLabel={facilityName} trueFormSpec={dbFormSpec} decorative={true} />
                    <div style={{ marginTop: 20 }}>{SectionTitles[1]}</div>
                    <div style={{ height: 100, background: 'rgb(240, 240, 240)', padding: 10, marginTop: 10, marginBottom: 20 }}>{selectedItems}</div>
                    <div className='facilities-physicians'>
                        {
                            <div id='ordinary-facilities' className='form-fields' style={{}}>
                                {dbFormSpec.release.facilities.map((item, index) => {
                                    return (
                                        (item.location === 1) &&
                                        <>
                                            <div className='facility-item' key={index}><CheckField checkboxType={'facility'} formik={formik} formValue={item.key} checkItemLabel={item.value} trueFormSpec={dbFormSpec} tooltip={item.tooltip} /></div>
                                        </>
                                    )
                                })
                                }

                            </div>}
                        <div style={{ marginTop: 20, marginBottom: 10 }}>{SectionTitles[2]}</div>
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {dbFormSpec.release.facilities.map((item, index) => {
                                return (
                                    (item.location === 2) &&
                                    <>
                                        <div className='facility-item' key={index}><CheckField checkboxType={'facility'} formik={formik} formValue={item.key} checkItemLabel={item.value} trueFormSpec={dbFormSpec} tooltip={item.tooltip} /></div>
                                    </>
                                )
                            })}
                        </div>
                        <div style={{ marginTop: 20, marginBottom: 10 }}>{SectionTitles[3]}</div>
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {dbFormSpec.release.facilities.map((item, index) => {
                                return (
                                    (item.location === 3) &&
                                    <>
                                        <div className='facility-item' key={index}><CheckField checkboxType={'facility'} formik={formik} formValue={item.key} checkItemLabel={item.value} trueFormSpec={dbFormSpec} tooltip={item.tooltip} /></div>
                                    </>
                                )
                            })}
                        </div>
                        <div id="CustomText">{dbFormSpec.AuthorizationToReleaseCustomText ? dbFormSpec.AuthorizationToReleaseCustomText : ""} </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FacilitiesSelectionList;





